import { Comment } from "./comment";
import { Platform } from "./ad-platforms";
import { AspectRatio } from "../features/ad-publishing/types";

export interface AdAssetGroupData {
  name: string;
  description: string;
  platforms?: Platform[];
  aspect_ratios?: AspectRatio[];
  tracking_id_start: number;
  google_ad_group_id?: string;
  meta_ad_set_id?: string;
  msan_ad_group_id?: string;
  google_campaign_name?: string;
  google_ad_group_name?: string;
  google_ad_group_url?: string;
  meta_campaign_name?: string;
  msan_campaign_name?: string;
  msan_ad_group_name?: string;
  msan_ad_group_url?: string;
  meta_ad_set_name?: string;
  meta_ad_set_url?: string;
  preferred_aspect_ratio_for_placements?: "feed" | "square";
}

// Shared interface for tracking ID inclusion state
export interface TrackingIdInclusionState {
  google_destination_url: boolean;
  facebook_destination_url: boolean;
  msan_destination_url: boolean;
  name: boolean;
}

export interface AdAssetGroup extends AdAssetGroupData {
  id: number;
  created_at: string;
  updated_at: string;
  status: string;
  comments: Comment[];
}

export enum AdAssetGroupStatusEnum {
  NEW = "new",
  ASSEMBLING = "assembling",
  FAILED = "failed",
  DRAFT = "draft",
  READY_FOR_REVIEW = "ready_for_review",
  READY_TO_PUBLISH = "ready_to_publish",
  REVISING = "revising",
  PUBLISHING = "publishing",
  PUBLISHED = "published",
  PARTIAL_PUBLISH = "partial_publish",
  PARTIAL_FAILURE = "partial_failure"
}

/** Statuses where a locked AAG is eligible for customer re-entry (to view/update edit requests). */
export const REVISING_ELIGIBLE_STATUSES: ReadonlySet<AdAssetGroupStatusEnum> = new Set([
  AdAssetGroupStatusEnum.READY_FOR_REVIEW,
  AdAssetGroupStatusEnum.READY_TO_PUBLISH
]);

export type AdAssetGroupStatus =
  | AdAssetGroupStatusEnum.ASSEMBLING
  | AdAssetGroupStatusEnum.NEW
  | AdAssetGroupStatusEnum.DRAFT
  | AdAssetGroupStatusEnum.READY_FOR_REVIEW
  | AdAssetGroupStatusEnum.READY_TO_PUBLISH
  | AdAssetGroupStatusEnum.REVISING
  | AdAssetGroupStatusEnum.PUBLISHING
  | AdAssetGroupStatusEnum.PUBLISHED
  | AdAssetGroupStatusEnum.PARTIAL_PUBLISH
  | AdAssetGroupStatusEnum.PARTIAL_FAILURE
  | AdAssetGroupStatusEnum.FAILED;
